/**
 * RAG Tailor's - formulários partilhados
 * 1) Consentimento obrigatório: botões marcados com [data-rt-consent-lock] ficam
 *    inativos até a caixa [data-rt-consent] do mesmo formulário estar marcada;
 *    um clique com a caixa por marcar "ilumina" a caixa.
 * 2) Pedidos de stock na página de produto (snippet rt-stock-request):
 *    - "Disponibilidade do artigo": pedido de orçamento (request_type insufficient_stock)
 *    - "Avise-me quando repor": registo na função Supabase restock-subscribe
 */
(function () {
  'use strict';
  if (window.RtForms) return;

  var RESTOCK_ENDPOINT = 'https://crtmzyzchtvcrkkhaipv.supabase.co/functions/v1/restock-subscribe';
  var QUOTE_ENDPOINT = 'https://crtmzyzchtvcrkkhaipv.supabase.co/functions/v1/shopify-quote-webhook';
  var STOCK_NOTE = 'Pedido de cliente: artigo com stock insuficiente.';

  /* ---------------- Consentimento obrigatório ---------------- */

  function consentInput(form) {
    return form ? form.querySelector('[data-rt-consent] input[type="checkbox"]') : null;
  }

  function lockButtons(form, locked) {
    if (!form) return;
    form.querySelectorAll('[data-rt-consent-lock]').forEach(function (btn) {
      btn.classList.toggle('is-consent-locked', locked);
      btn.setAttribute('aria-disabled', locked ? 'true' : 'false');
    });
  }

  function syncConsent(form) {
    var input = consentInput(form);
    if (input) lockButtons(form, !input.checked);
  }

  function flashConsent(form) {
    var label = form.querySelector('[data-rt-consent]');
    if (!label) return;
    label.classList.remove('is-flash');
    void label.offsetWidth;
    label.classList.add('is-flash', 'is-invalid');
    var rect = label.getBoundingClientRect();
    if (rect.top < 0 || rect.bottom > window.innerHeight) {
      label.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    var input = consentInput(form);
    if (input) input.focus({ preventScroll: true });
  }

  function consentMissing(form) {
    var input = consentInput(form);
    return !!input && !input.checked;
  }

  document.addEventListener('change', function (e) {
    var input = e.target.closest ? e.target.closest('[data-rt-consent] input[type="checkbox"]') : null;
    if (!input || !input.form) return;
    lockButtons(input.form, !input.checked);
    if (input.checked) {
      var label = input.closest('[data-rt-consent]');
      label.classList.remove('is-flash', 'is-invalid');
    }
  });

  // Fase de captura: corre antes dos handlers do próprio formulário (ex.: quote-form.js)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-rt-consent-lock]') : null;
    if (!btn) return;
    var form = btn.form || btn.closest('form');
    if (!consentMissing(form)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    flashConsent(form);
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!consentMissing(form)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    flashConsent(form);
  }, true);

  document.addEventListener('reset', function (e) {
    var form = e.target;
    setTimeout(function () { syncConsent(form); }, 0);
  }, true);

  function initConsent() {
    document.querySelectorAll('[data-rt-consent]').forEach(function (label) {
      var input = label.querySelector('input[type="checkbox"]');
      if (input && input.form) syncConsent(input.form);
    });
  }

  /* ---------------- Modais ---------------- */

  var openModalEl = null;

  function openModal(modal, trigger) {
    if (!modal) return;
    if (openModalEl && openModalEl !== modal) closeModal(openModalEl, true);
    modal._trigger = trigger || document.activeElement;
    // No fim do body para ficar por cima do popup "Escolher Cor e Tamanho" (mesmo z-index)
    if (modal.parentNode !== document.body) document.body.appendChild(modal);
    modal.hidden = false;
    document.documentElement.classList.add('rt-modal-open');
    requestAnimationFrame(function () { modal.classList.add('is-open'); });
    openModalEl = modal;
    setTimeout(function () {
      var first = modal.querySelector('.rt-modal__view:not([hidden]) input:not([type="hidden"]):not([tabindex="-1"]), .rt-modal__view:not([hidden]) button');
      if (first) first.focus({ preventScroll: true });
    }, 60);
  }

  function closeModal(modal, instant) {
    if (!modal || modal.hidden) return;
    modal.classList.remove('is-open');
    document.documentElement.classList.remove('rt-modal-open');
    if (openModalEl === modal) openModalEl = null;
    var finish = function () { modal.hidden = true; };
    if (instant) finish(); else setTimeout(finish, 220);
    if (modal._trigger && typeof modal._trigger.focus === 'function') modal._trigger.focus({ preventScroll: true });
  }

  function showView(modal, name) {
    modal.querySelectorAll('.rt-modal__view').forEach(function (view) {
      view.hidden = view.getAttribute('data-view') !== name;
    });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var closer = e.target.closest('[data-rt-modal-close]');
    if (closer) {
      closeModal(closer.closest('.rt-modal'));
      return;
    }
    var reload = e.target.closest('[data-rt-reload]');
    if (reload) window.location.reload();
  });

  document.addEventListener('keydown', function (e) {
    if (!openModalEl) return;
    if (e.key === 'Escape') {
      closeModal(openModalEl);
      return;
    }
    if (e.key !== 'Tab') return;
    var focusable = Array.prototype.filter.call(
      openModalEl.querySelectorAll('a[href], button, input:not([type="hidden"]), textarea, select'),
      function (el) { return !el.disabled && el.offsetParent !== null && el.tabIndex !== -1; }
    );
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });

  /* ---------------- Dados do produto / variante ---------------- */

  function config(sectionId) {
    var el = document.getElementById('RtStockCfg-' + sectionId);
    if (!el) return null;
    if (!el._cfg) {
      try { el._cfg = JSON.parse(el.textContent); } catch (err) { el._cfg = null; }
    }
    return el._cfg;
  }

  function currentVariant(sectionId) {
    var picker = document.getElementById('variant-selects-' + sectionId);
    var form = document.getElementById('product-form-' + sectionId);
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var id = idInput ? Number(idInput.value) : 0;
    if (picker && picker.currentVariant && (!id || picker.currentVariant.id === id)) return picker.currentVariant;
    var list = null;
    try {
      if (picker && typeof picker.getVariantData === 'function') list = picker.getVariantData();
      else {
        var json = document.getElementById('variants' + sectionId);
        list = json ? JSON.parse(json.textContent) : null;
      }
    } catch (err) { list = null; }
    if (!list) return null;
    for (var i = 0; i < list.length; i++) {
      if (list[i].id === id) return list[i];
    }
    return null;
  }

  function variantImage(variant, cfg) {
    var src = (variant && variant.featured_image && variant.featured_image.src) || cfg.image || '';
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=160';
  }

  function variantParts(variant, cfg) {
    var opts = (variant && variant.options) || [];
    var color = cfg.colorIndex > -1 ? (opts[cfg.colorIndex] || '') : '';
    var size = '';
    for (var i = 0; i < opts.length; i++) {
      if (i !== cfg.colorIndex) { size = opts[i]; break; }
    }
    return { color: color, size: size };
  }

  function variantLabel(variant) {
    if (!variant || !variant.title || variant.title === 'Default Title') return '';
    return variant.title;
  }

  function requestedQty(sectionId) {
    var input = document.getElementById('Quantity-' + sectionId);
    var qty = input ? parseInt(input.value, 10) : 1;
    return qty > 0 ? qty : 1;
  }

  function fillProductCard(modal, cfg, variant) {
    var src = variantImage(variant, cfg);
    var label = variantLabel(variant);
    var sku = variant && variant.sku ? variant.sku : '';
    modal.querySelectorAll('.rt-modal__product').forEach(function (card) {
      var img = card.querySelector('img');
      if (img) {
        if (src) { img.src = src; img.parentNode.hidden = false; }
        else img.parentNode.hidden = true;
      }
      var title = card.querySelector('.rt-modal__product-title');
      if (title) title.textContent = cfg.title;
      var meta = card.querySelector('.rt-modal__product-variant');
      if (meta) meta.textContent = [label, sku].filter(Boolean).join(' · ');
    });
  }

  // Variante pedida por id (compra em quantidade); sem ela, a variante escolhida
  function variantById(sectionId, id) {
    if (!id) return null;
    var picker = document.getElementById('variant-selects-' + sectionId);
    var list = null;
    try {
      if (picker && typeof picker.getVariantData === 'function') list = picker.getVariantData();
      else {
        var json = document.getElementById('variants' + sectionId);
        list = json ? JSON.parse(json.textContent) : null;
      }
    } catch (err) { list = null; }
    if (!list) return null;
    for (var i = 0; i < list.length; i++) {
      if (String(list[i].id) === String(id)) return list[i];
    }
    return null;
  }

  function triggerVariant(sectionId, trigger) {
    var id = trigger && trigger.getAttribute ? trigger.getAttribute('data-variant-id') : null;
    return variantById(sectionId, id) || currentVariant(sectionId);
  }

  function triggerQty(sectionId, trigger) {
    var q = trigger && trigger.getAttribute ? parseInt(trigger.getAttribute('data-qty'), 10) : 0;
    return q > 0 ? q : requestedQty(sectionId);
  }

  function quoteHref(sectionId, trigger) {
    var cfg = config(sectionId);
    if (!cfg || !cfg.quoteUrl) return null;
    var variant = triggerVariant(sectionId, trigger);
    var parts = variantParts(variant, cfg);
    var params = new URLSearchParams();
    params.set('rt_product', cfg.title);
    params.set('rt_stock', '1');
    if (variant && variant.sku) params.set('rt_ref', variant.sku);
    if (parts.color) params.set('rt_color', parts.color);
    if (parts.size) params.set('rt_size', parts.size);
    var askQty = document.querySelector('#RtAsk-' + sectionId + ' input[name="rt_quantity"]');
    var qty = askQty && openModalEl && openModalEl.id === 'RtAsk-' + sectionId ? parseInt(askQty.value, 10) : triggerQty(sectionId, trigger);
    params.set('rt_qty', qty > 0 ? qty : 1);
    var img = variantImage(variant, cfg);
    if (img) params.set('rt_img', img);
    return cfg.quoteUrl + (cfg.quoteUrl.indexOf('?') > -1 ? '&' : '?') + params.toString();
  }

  // Links "Pedir orçamento": o href é calculado no clique, com a variante escolhida
  document.addEventListener('click', function (e) {
    var link = e.target.closest ? e.target.closest('[data-rt-quote]') : null;
    if (!link) return;
    var href = quoteHref(link.getAttribute('data-rt-quote'), link);
    if (href) link.href = href;
  });

  /* ---------------- Disponibilidade do artigo (contacto Shopify) ---------------- */

  function openAsk(sectionId, trigger) {
    var modal = document.getElementById('RtAsk-' + sectionId);
    var cfg = config(sectionId);
    if (!modal || !cfg) return;
    var variant = triggerVariant(sectionId, trigger);
    var form = modal.querySelector('form');
    var parts = variantParts(variant, cfg);
    // Artigo do pedido, guardado ao abrir (a variante pode mudar depois)
    form._item = {
      reference: variant && variant.sku ? variant.sku : '',
      product: cfg.title,
      color: parts.color,
      size: parts.size,
      image: variantImage(variant, cfg),
      link: window.location.origin + cfg.url + (variant ? '?variant=' + variant.id : '')
    };
    var qty = form.querySelector('[name="rt_quantity"]');
    if (qty) qty.value = triggerQty(sectionId, trigger);
    fillProductCard(modal, cfg, variant);
    setFormError(form, '');
    showView(modal, 'form');
    openModal(modal, trigger);
  }

  function setFormError(form, message) {
    var box = form.querySelector('.rt-modal__error');
    if (!box) return;
    box.textContent = message || '';
    box.hidden = !message;
  }

  function setLoading(form, loading) {
    var btn = form.querySelector('[type="submit"]');
    if (!btn) return;
    btn.classList.toggle('is-loading', loading);
    btn.disabled = loading;
  }

  function submitAsk(form) {
    var modal = form.closest('.rt-modal');
    var cfg = config(modal.getAttribute('data-section'));
    if (!form.reportValidity()) return;
    var value = function (name) {
      var input = form.querySelector('[name="' + name + '"]');
      return input ? input.value.trim() : '';
    };
    var item = form._item || { product: cfg.title, reference: '', color: '', size: '', image: '', link: '' };
    var message = value('notes');
    var notes = STOCK_NOTE + (message ? '\n\n' + message : '') + (item.link ? '\n\nLink: ' + item.link : '');

    // Mesmo formato (FormData) do formulário de orçamento (quote-form.js)
    var data = new FormData();
    data.append('request_type', 'insufficient_stock');
    data.append('customer_name', value('customer_name'));
    data.append('customer_email', value('customer_email'));
    data.append('customer_phone', value('customer_phone'));
    data.append('country', cfg.country || '');
    data.append('notes', notes);
    data.append('details', JSON.stringify({
      items: [{
        reference: item.reference,
        product: item.product,
        color: item.color,
        size: item.size,
        quantity: parseInt(value('rt_quantity'), 10) || 1,
        image: item.image
      }]
    }));

    setFormError(form, '');
    setLoading(form, true);
    fetch(QUOTE_ENDPOINT, { method: 'POST', body: data })
      .then(function (res) {
        if (res.ok) {
          showView(modal, 'success');
          form.reset();
          return;
        }
        setFormError(form, cfg.strings.error_generic);
      })
      .catch(function () {
        setFormError(form, cfg.strings.error_generic);
      })
      .finally(function () {
        setLoading(form, false);
      });
  }

  /* ---------------- Avise-me quando repor (Supabase) ---------------- */

  function openRestock(sectionId, variantId, trigger) {
    var modal = document.getElementById('RtRestock-' + sectionId);
    var cfg = config(sectionId);
    if (!modal || !cfg) return;
    var variant = currentVariant(sectionId);
    var form = modal.querySelector('form');
    form.querySelector('[name="variant_id"]').value = variantId || (variant ? variant.id : '');
    fillProductCard(modal, cfg, variant);
    setFormError(form, '');
    form.querySelectorAll('.is-error').forEach(function (el) { el.classList.remove('is-error'); });
    showView(modal, 'form');
    openModal(modal, trigger);
  }

  function submitRestock(form) {
    var modal = form.closest('.rt-modal');
    var cfg = config(modal.getAttribute('data-section'));
    var s = cfg.strings;
    form.querySelectorAll('.is-error').forEach(function (el) { el.classList.remove('is-error'); });
    if (!form.reportValidity()) return;
    var value = function (name) {
      var input = form.querySelector('[name="' + name + '"]');
      return input ? input.value.trim() : '';
    };
    var payload = {
      email: value('email'),
      variant_id: value('variant_id'),
      locale: cfg.locale,
      page_url: window.location.href,
      website: value('website')
    };
    if (value('phone')) payload.phone = value('phone');
    if (value('name')) payload.name = value('name');

    setFormError(form, '');
    setLoading(form, true);
    fetch(RESTOCK_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (data) {
          return { status: res.status, data: data || {} };
        });
      })
      .then(function (r) {
        if (r.status === 200) {
          if (r.data.status === 'available') {
            showView(modal, 'available');
          } else {
            showView(modal, 'success');
            form.reset();
          }
          return;
        }
        if (r.status === 400) {
          if (r.data.code === 'invalid_email') return fieldError(form, 'email', s.error_email);
          if (r.data.code === 'invalid_phone') return fieldError(form, 'phone', s.error_phone);
          if (r.data.code === 'invalid_variant') return setFormError(form, s.error_variant);
        }
        if (r.status === 429) return setFormError(form, s.error_rate);
        setFormError(form, s.error_generic);
      })
      .catch(function () {
        setFormError(form, s.error_generic);
      })
      .finally(function () {
        setLoading(form, false);
      });
  }

  function fieldError(form, name, message) {
    var input = form.querySelector('[name="' + name + '"]');
    if (input) {
      input.closest('.rt-field').classList.add('is-error');
      input.focus();
    }
    setFormError(form, message);
  }

  /* ---------------- Selo de stock ao escrever a quantidade ----------------
     O stock só é pedido à loja (product.rt-stock.liquid) quando o cliente escreve,
     meio segundo depois de parar; a resposta fica 30 s em memória. */

  var stockCache = {};
  var qtyTimers = {};

  function qtySection(input) {
    var m = input && input.id ? input.id.match(/^(?:stDrawerQuantity|Quantity)-(.+)$/) : null;
    if (!m) return null;
    var cfg = config(m[1]);
    return cfg && cfg.qtyCheck ? m[1] : null;
  }

  function fetchStock(cfg, id) {
    var hit = stockCache[id];
    if (hit && Date.now() - hit.t < 30000) return Promise.resolve(hit.d);
    var url = cfg.url + (cfg.url.indexOf('?') > -1 ? '&' : '?') + 'variant=' + id + '&view=rt-stock';
    return fetch(url, { credentials: 'same-origin' })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) {
        if (data) stockCache[id] = { t: Date.now(), d: data };
        return data;
      })
      .catch(function () { return null; });
  }

  function setQtyStock(sectionId, html) {
    ['RtQtyStock-', 'RtQtyStockDrawer-'].forEach(function (prefix) {
      var slot = document.getElementById(prefix + sectionId);
      if (!slot) return;
      slot.innerHTML = html || '';
      slot.hidden = !html;
    });
  }

  function checkQtyStock(sectionId) {
    var cfg = config(sectionId);
    var picker = document.getElementById('variant-selects-' + sectionId);
    var form = document.getElementById('product-form-' + sectionId);
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var main = document.getElementById('Quantity-' + sectionId);
    var typed = main ? parseInt(main.value, 10) : 0;
    var sizeMissing = picker && typeof picker.isSizeUnselected === 'function' && picker.isSizeUnselected();
    if (!cfg || !idInput || !idInput.value || idInput.disabled || sizeMissing || !(typed > 1)) {
      setQtyStock(sectionId, '');
      return;
    }
    var id = idInput.value;
    fetchStock(cfg, id).then(function (d) {
      /* Resposta atrasada de outra variante ou quantidade já alterada: ignora */
      if (idInput.value !== id || parseInt(main.value, 10) !== typed) return;
      if (!d || !d.managed || !d.deny || !d.available) { setQtyStock(sectionId, ''); return; }
      var inCart = parseInt(main.getAttribute('data-cart-quantity'), 10) || 0;
      var free = d.qty - inCart;
      if (typed <= free) { setQtyStock(sectionId, ''); return; }
      var tpl = document.getElementById('RtQtyStockTpl-' + sectionId);
      if (!tpl) return;
      var box = document.createElement('div');
      box.appendChild(tpl.content.cloneNode(true));
      var s = cfg.strings;
      var text = free > 0 ? s.low_stock.replace('__Q__', free) : s.all_in_cart;
      if (inCart > 0 && free > 0) text += ' ' + s.in_cart.replace('__C__', inCart);
      box.querySelector('[data-rt-qty-text]').textContent = text;
      setQtyStock(sectionId, box.innerHTML);
    });
  }

  function scheduleQtyCheck(sectionId) {
    clearTimeout(qtyTimers[sectionId]);
    qtyTimers[sectionId] = setTimeout(function () { checkQtyStock(sectionId); }, 500);
  }

  ['input', 'change'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      var sectionId = qtySection(e.target);
      if (sectionId) scheduleQtyCheck(sectionId);
    });
  });

  // Botões − / + da página e do popup alteram o valor sem evento "input"
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.qtyBtn') : null;
    if (!btn) return;
    var input = btn.parentNode ? btn.parentNode.querySelector('input') : null;
    var sectionId = qtySection(input);
    if (sectionId) scheduleQtyCheck(sectionId);
  });

  function initQtyCheck() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    // Nova variante: volta a verificar a quantidade já escrita
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var sectionId = event && event.data ? event.data.sectionId : null;
      if (sectionId && config(sectionId) && config(sectionId).qtyCheck) scheduleQtyCheck(sectionId);
    });
    // Depois de adicionar ao carrinho a quantidade volta ao mínimo: limpa o selo
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      stockCache = {};
      document.querySelectorAll('.rt-qty-stock-slot').forEach(function (slot) {
        slot.innerHTML = '';
        slot.hidden = true;
      });
    });
  }

  /* ---------------- Página de contactos -> CRM (request_type "contact") ---------------- */

  function submitContact(form) {
    var modal = document.getElementById('RtContactDone');
    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.textContent : '';
    var value = function (name) {
      var input = form.querySelector('[name="' + name + '"]');
      return input ? input.value.trim() : '';
    };
    var payload = { request_type: 'contact', customer_email: value('contact[email]') };
    var optional = {
      customer_name: value('contact[name]'),
      customer_phone: value('contact[phone]'),
      subject: value('contact[form subject]'),
      notes: value('contact[body]')
    };
    Object.keys(optional).forEach(function (key) { if (optional[key]) payload[key] = optional[key]; });

    var show = function (view) {
      if (!modal) return;
      showView(modal, view);
      openModal(modal, btn);
    };
    if (btn) {
      btn.disabled = true;
      if (btn.getAttribute('data-sending')) btn.textContent = btn.getAttribute('data-sending');
    }
    fetch(QUOTE_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (data) {
          if (res.ok && data && data.success) {
            form.reset();
            show('success');
          } else {
            show('error');
          }
        });
      })
      .catch(function () { show('error'); })
      .finally(function () {
        if (btn) { btn.disabled = false; btn.textContent = label; }
      });
  }

  /* ---------------- Ligações ---------------- */

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var ask = e.target.closest('[data-rt-ask]');
    if (ask) {
      e.preventDefault();
      openAsk(ask.getAttribute('data-rt-ask'), ask);
      return;
    }
    var restock = e.target.closest('[data-rt-restock]');
    if (restock) {
      e.preventDefault();
      openRestock(restock.getAttribute('data-rt-restock'), restock.getAttribute('data-variant-id'), restock);
      return;
    }
    var step = e.target.closest('[data-rt-qty]');
    if (step) {
      var qtyInput = step.parentNode.querySelector('input');
      var next = (parseInt(qtyInput.value, 10) || 1) + parseInt(step.getAttribute('data-rt-qty'), 10);
      qtyInput.value = Math.max(1, next);
      return;
    }
    var dismiss = e.target.closest('.rt-cart-error__close');
    if (dismiss) {
      var wrap = dismiss.closest('.product-form__error-message-wrapper');
      if (wrap) wrap.hidden = true;
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.matches('[data-rt-ask-form]')) {
      e.preventDefault();
      submitAsk(form);
    } else if (form.matches('[data-rt-contact-form]')) {
      e.preventDefault();
      submitContact(form);
    } else if (form.matches('[data-rt-restock-form]')) {
      e.preventDefault();
      submitRestock(form);
    }
  });

  function init() {
    initConsent();
    initQtyCheck();
    // Envio tradicional (sem JS) da página de contactos: mostra o popup em vez da barra da Shopify
    var posted = document.querySelector('.rt-modal[data-rt-open]');
    if (posted) {
      showView(posted, posted.getAttribute('data-rt-open'));
      openModal(posted);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.RtForms = {
    openModal: openModal,
    closeModal: closeModal,
    syncConsent: syncConsent,
    // Stock de uma variante (compra em quantidade): { qty, managed, deny, available } ou null
    stock: function (productUrl, variantId) { return fetchStock({ url: productUrl }, variantId); }
  };
})();
